export const LOADING_RESPONSIBLEFACTOR = "LOADING_RESPONSIBLEFACTOR";
export const SAVE_LOADING_RESPONSIBLEFACTOR = "SAVE_LOADING_RESPONSIBLEFACTOR";
export const GET_RESPONSIBLEFACTOR = "GET_RESPONSIBLEFACTOR";
export const FORM_FAIL = "FORM_FAIL";
export const RESPONSIBLEFACTOR_FAIL = "RESPONSIBLEFACTOR_FAIL";
export const GET_RESPONSIBLEFACTOR_BY_ID = "GET_RESPONSIBLEFACTOR_BY_ID";

//unidades
export const LOADING_ORGANIZATIONALUNIT = "LOADING_ORGANIZATIONALUNIT";
export const GET_ORGANIZATIONALUNIT = "GET_ORGANIZATIONALUNIT";
export const ORGANIZATIONALUNIT_FAIL = "ORGANIZATIONALUNIT_FAIL";

//factores criterios
export const LOADING_FACTORCRITERION = "LOADING_FACTORCRITERION";
export const GET_FACTORCRITERION = "GET_FACTORCRITERION";
export const FACTORCRITERION_FAIL = "FACTORCRITERION_FAIL";
